import React from 'react';
import Toggle from './Toggle';
import styles from './ActivityStatus.module.scss';

function ActivityStatus({ isActive = false, activate }) {
  const handleToggleClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className={styles['activity-row']} onClick={handleToggleClick}>
      {isActive ? (
        <p className={styles['status-text']}>الحالة: نشط</p>
      ) : (
        <p className={styles['status-text-inactive']}>الحالة: غير نشط</p>
      )}
      <Toggle
        isActive={isActive}
        color="blue"
        onChange={() => {
          activate.mutate();
        }}
      />
    </div>
  );
}

export default ActivityStatus;
